/**
 * @generated SignedSource<<4a7a5d3065f6226aaa5dbd47cc52cc23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckHasSeriesShortLabelContent$data = {
  readonly seriesContainer?: {
    readonly seriesShortLabel: string | null | undefined;
  } | null | undefined;
  readonly seriesShortLabel?: string | null | undefined;
  readonly " $fragmentType": "helpersCheckHasSeriesShortLabelContent";
};
export type helpersCheckHasSeriesShortLabelContent$key = {
  readonly " $data"?: helpersCheckHasSeriesShortLabelContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckHasSeriesShortLabelContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckHasSeriesShortLabelContent"
};

(node as any).hash = "956068519c18c7c63858583f2745eb16";

export default node;
